const mod = require('../../bahabot.module.js');

function bbDiscordRolePickerController($timeout, $element, $document, DiscordService) {
    const ctrl = this;

    ctrl.availableRoles = [];
    ctrl.selectedRoles = [];
    ctrl.selectedRoleIds = [];
    ctrl.searchText = '';
    ctrl.menuOpen = false;
    ctrl.loading = false;
    let clickListener;

    // no state reset here: the initial $onChanges runs first and may already be loading roles
    ctrl.$onInit = function () {
        clickListener = (event) => {
            if (!$element[0].contains(event.target)) {
                $timeout(() => {
                    ctrl.menuOpen = false;
                })
            }
        }
        $document.on('click', clickListener)
        ctrl.parseModel();
    };

    ctrl.$onChanges = function (changes) {
        if (changes.guildId && changes.guildId.currentValue) {
            ctrl.loadRoles();
        }
        if (changes.model && changes.model.currentValue !== undefined) {
            ctrl.parseModel();
        }
    };

    ctrl.$onDestroy = function () {
        if (clickListener) {
            $document.off('click', clickListener);
        }
    };

    ctrl.loadRoles = function () {
        if (!ctrl.guildId) return;
        ctrl.loading = true;
        DiscordService.fetchRoles(ctrl.guildId).then(roles => {
            ctrl.availableRoles = (roles || []).filter(r => r.name !== '@everyone' && !r.managed);
            ctrl.syncSelectedRoles();
            ctrl.loading = false;
        }).catch(() => {
            ctrl.availableRoles = [];
            ctrl.loading = false;
        });
    };

    ctrl.parseModel = function () {
        try {
            ctrl.selectedRoleIds = JSON.parse(ctrl.model || '[]');
        } catch {
            ctrl.selectedRoleIds = [];
        }
        ctrl.syncSelectedRoles();
    };

    ctrl.syncSelectedRoles = function () {
        ctrl.selectedRoles = ctrl.availableRoles.filter(r => ctrl.selectedRoleIds.includes(r.id));
    };

    ctrl.addRole = function (role) {
        if (!ctrl.selectedRoleIds.includes(role.id)) {
            ctrl.selectedRoleIds.push(role.id);
            ctrl.model = JSON.stringify(ctrl.selectedRoleIds);
            ctrl.syncSelectedRoles();
        }
        ctrl.menuOpen = false;
        ctrl.searchText = '';
    };

    ctrl.removeRole = function (role) {
        ctrl.selectedRoleIds = ctrl.selectedRoleIds.filter(id => id !== role.id);
        ctrl.model = JSON.stringify(ctrl.selectedRoleIds);
        ctrl.syncSelectedRoles();
    };

    ctrl.filteredRoles = function () {
        const q = (ctrl.searchText || '').toLowerCase();
        return ctrl.availableRoles.filter(r =>
            !ctrl.selectedRoleIds.includes(r.id) &&
            r.name.toLowerCase().includes(q)
        );
    };

    ctrl.toggleMenu = function () {
        ctrl.menuOpen = !ctrl.menuOpen;
        if (ctrl.menuOpen) {
            ctrl.searchText = '';
        }
    };

    ctrl.roleColorStyle = function (role) {
        if (!role.color || role.color === 0) return {};
        const hex = role.color.toString(16).padStart(6, '0');
        return { 'background-color': '#' + hex };
    };
}

mod.component('bbDiscordRolePicker', {
    template: `
<div class="relative">
    <div class="flex flex-wrap gap-1 min-h-[38px] p-1 bg-gray-50 border border-gray-300 rounded-lg dark:bg-gray-700 dark:border-gray-600">
        <span ng-repeat="role in $ctrl.selectedRoles"
              class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs text-white">
            <span class="w-2 h-2 rounded-full inline-block" ng-style="$ctrl.roleColorStyle(role)"></span>
            <span class="text-gray-600 dark:text-gray-200">{{role.name}}</span>
            <button ng-click="$ctrl.removeRole(role)" class="ml-1 text-gray-400 hover:text-red-400">&times;</button>
        </span>
        <span ng-if="$ctrl.loading" class="inline-flex items-center px-2 text-gray-400 dark:text-slate-400">
            <i class="fa-solid fa-spinner animate-spin inline-block"></i>
        </span>
        <input type="text"
               ng-model="$ctrl.searchText"
               ng-focus="$ctrl.menuOpen = true"
               placeholder="{{$ctrl.loading ? 'Loading roles...' : (!$ctrl.selectedRoles.length ? 'Add roles...' : '')}}"
               class="bg-transparent border-none outline-none text-sm flex-1 min-w-[80px] p-1 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-400"
               autocomplete="off" />
    </div>
    <div ng-if="$ctrl.menuOpen"
          class="absolute left-0 right-0 z-50 max-h-48 overflow-auto rounded shadow-lg bg-gray-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 mt-1">
        <div ng-if="$ctrl.loading" class="px-3 py-2 text-gray-400 dark:text-slate-400 italic"><i class="fa-solid fa-spinner animate-spin inline-block mr-2"></i>Loading roles...</div>
        <div ng-if="!$ctrl.loading && $ctrl.filteredRoles().length === 0"
             class="px-3 py-2 text-gray-400 dark:text-slate-500 italic">No roles found.</div>
        <ul ng-if="!$ctrl.loading">
            <li ng-repeat="role in $ctrl.filteredRoles()"
                ng-click="$ctrl.addRole(role)"
                class="px-3 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 cursor-pointer flex items-center gap-2">
                <span class="w-3 h-3 rounded-full inline-block" ng-style="$ctrl.roleColorStyle(role)"></span>
                <span class="text-gray-900 dark:text-white">{{role.name}}</span>
            </li>
        </ul>
    </div>
</div>
    `,
    bindings: {
        guildId: '<',
        model: '=',
    },
    controller: ['$timeout', '$element', '$document', 'DiscordService', bbDiscordRolePickerController]
});